module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[89]88.30a5435.woff2";